/**
 * osi Group
 * @param fb : FormBuilder
 */
export function osiGroup (fb: any) {
    fb.group({
        carrier: [''],
        text: ['']
    })
}
